var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
_global.SENTRY_RELEASE = {
  id: "0ae86af81542b4cefea1d39a81666e2609123e7c"
};
_global.SENTRY_RELEASES = _global.SENTRY_RELEASES || {};
_global.SENTRY_RELEASES["www-ligonier-org@ligonier"] = {
  id: "0ae86af81542b4cefea1d39a81666e2609123e7c"
};